import './configs/i18n' // MUST be first — ensures i18n is initialized before any component renders

import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'

import './index.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
